import { render } from "./template.html?vue&type=template&id=14721a2f&scoped=true&ts=true&external"
import script from "./Races.vue?vue&type=script&lang=ts"
export * from "./Races.vue?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&id=14721a2f&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14721a2f"]])

export default __exports__